export default "__VITE_ASSET__6513a916__"